<template>
  <section>
    <header-row-sector
      :image-url="require('~/assets/img/marketing.svg')"
      :title="page.title"
      :content="page.tekst"
    />
    <div class="bg-card bg-no-repeat bg-cover py-64 xl:py-96">
      <card class="mt-20"/>
    </div>
    <text-block
      :image-url="require('~/assets/img/bericht.svg')"
      :link="false"
      :reverse="true"
      :title="page.kop_2"
      :content="page.tekst_2"
      class="-mt-32 pt-0 pb-10"
    />
    <text-block
      :image-url="require('~/assets/img/marketing.svg')"
      :link="false"
      class="pt-0 pb-10"
      :title="page.kop_3"
      :content="page.tekst_3"
    />
    <call-to-action
      title="Ik ben om!"
      content="Een kopje koffie komen drinken? Gezellig!"
    />
    <usps
      class="-mt-40 xxl:mb-24"
    />
  </section>
</template>

<script>
import CallToAction from '~/components/CallToAction';
import Card from '~/components/Card';
import HeaderRowSector from '~/components/HeaderRowSector';
import TextBlock from '~/components/TextBlock';
import Usps from '~/components/Usps';
import page from '~/plugins/mixins/page';

export default {
  components: {
    CallToAction,
    Card,
    HeaderRowSector,
    TextBlock,
    Usps,
  },
  mixins: [page],
};
</script>

<style lang="sass" scoped>
.bg-card
  background-image: url("~assets/img/bg-usps.svg")
</style>
